import { render, staticRenderFns } from "./PostDetails.vue?vue&type=template&id=ff8b45ca"
import script from "./PostDetails.vue?vue&type=script&lang=js"
export * from "./PostDetails.vue?vue&type=script&lang=js"
import style0 from "./PostDetails.vue?vue&type=style&index=0&id=ff8b45ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports